<template>
  <v-container grid-list-md v-if="this.$store.getters.programsFetched">
    <v-layout row>
      <v-flex xs9>
        <h1>{{ $t('message.applicationList') }}</h1>
      </v-flex>
      <v-flex xs3>
        <v-text-field
          v-model="search"
          @keydown.enter.prevent="getAdminApplicationList()"
          append-icon="search" label="Search"
        />
      </v-flex>
    </v-layout>
    <v-layout row v-show="!loading">
      <v-flex>
        <v-data-table
          :headers="headers"
          :items="applications"
          :pagination.sync="pagination"
          :total-items="totalApplications"
          :rows-per-page-items="[10]"
          Default

          :loading="loading"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td>{{ props.item.applicationId }}</td>
            <td>{{ props.item.companyName }}</td>
            <td>{{ props.item.participantEmail }}</td>
            <td>
              {{ $t('message.dealerApplicationStatuses.' + props.item.status) }}
            </td>
            <td>
              {{ formatPreciseDate(props.item.lastUpdateDate) }}
            </td>
            <td>{{ formatDateOnly(props.item.expirationDate) }}</td>
            <td>{{ props.item.deleted | yesNo }}</td>
            <td>
              <v-menu offset-y open-on-hover>
                <template slot="activator">
                  <v-btn small fab>
                    <v-icon>list</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile>
                    <v-btn flat small round @click="showEvents(props.item)">
                      Events
                    </v-btn>
                  </v-list-tile>
                  <v-list-tile>
                    <v-btn flat small round @click="edit(props.item)">
                      Edit
                    </v-btn>
                  </v-list-tile>
                  <v-list-tile v-if="props.item.status == 0 || props.item.status == 1">
                    <v-btn  flat small round
                      @click="signOffApp(props.item)">
                      Sign Off
                    </v-btn>
                  </v-list-tile>
                  <v-list-tile v-if="props.item.status == 1 && !props.item.deleted">
                    <v-btn  flat small round
                      @click="resubmitApp(props.item)">
                      Resubmit
                    </v-btn>
                  </v-list-tile>
                  <v-list-tile v-if="props.item.status == 2">
                    <v-btn  flat small round
                      @click="underwrite(props.item)">
                      Underwrite
                    </v-btn>
                  </v-list-tile>
                  <v-list-tile v-if="(props.item.status == 1 || props.item.status == 2) && !props.item.deleted">
                    <v-btn  flat small round
                      @click="repackageApp(props.item)">
                      Repackage
                    </v-btn>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true"  type="info" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="white" v-show="loading">
      <v-flex xs24 sm12>
        <h1 class="text-xs-center" style="padding-bottom: 50px;">Loading...</h1>
      </v-flex>
      <v-flex xs24 sm12 style="padding-bottom: 50px;">
        <v-progress-circular
          style="width: 100%;"
          :size="70"
          :width="8"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-flex>
    </v-layout>

    <app-edit-dialog :lender-statuses="lenderStatuses"
                     :application="application"/>

    <v-dialog
      v-model="eventsDialog"
      @keydown.esc="eventsDialog = false"
      persistent
      scrollable
      max-width="900px"
    >
      <v-card>
        <v-card-title class="headline">
           Event History for Application {{this.application.id}}
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md class="no-top-padding" style="height: 40vh">
            <v-data-table
              :headers="eventsHeaders"
              :items="applicantEvents"
              hide-actions
              disable-initial-sort
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td>{{ formatPreciseDate(props.item.eventDate) }}</td>
                <td>{{ $t('message.dealerApplicationStatuses.' + props.item.status) }}</td>
                <td>{{ props.item.eventText }}</td>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat class="btn-primary"
            @click="eventsDialog = false"
          >
            {{ $t('message.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>

  </v-container>

</template>

<script>
import { axiosAuthInstance } from '../../main.js'
import listMixin from '@/mixins/listMixins'
import AppEditDialog from './AppEditDialog'
import { EventBus } from '../../main.js'
import App from "../../App.vue";

export default {
  data: () => ({
    totalApplications: 0,
    pagination: {
      page: 1,
      rowsPerPage: 10
    },
    search: '',
    loading: false,
    eventsDialog: false,
    applicationIndex: -1,
    application: {},
    applicantEvents: [],
    applications: [],
    lenderStatuses: [],
    eventsHeaders: [
      {text: 'Date', align: 'left', value: 'eventDate', width: '25%'},
      {text: 'Status', align: 'left', value: 'status', width: '20%', sortable: false},
      {text: 'Event', align: 'left', value: 'eventText', width: '55%', sortable: false}
    ],
    headers: [
      {
        text: 'Id',
        align: 'left',
        value: 'applicationId',
        width: '5%',
        sortable: false
      },
      {
        text: 'Company Name',
        value: 'companyName',
        width: '15%',
        sortable: false
      },
      {
        text: 'User',
        value: 'participantEmail',
        width: '20%',
        sortable: false
      },
      {
        text: 'Status',
        value: 'status',
        width: '10%',
        sortable: false
      },
      {
        text: 'Last Update Date',
        value: 'lastUpdateDate',
        width: '15%',
        sortable: false
      },
      {
        text: 'Expiration Date',
        value: 'expirationDate',
        width: '15%',
        sortable: false
      },
      {
        text: 'Deleted',
        value: 'deleted',
        width: '6%',
        sortable: false
      },
      {
        text: '',
        value: '',
        sortable: false
      }
    ],
    dealerName: '',
    doingBusinessAs: ''
  }),
  components: {
    App,
    AppEditDialog
  },
  mixins: [listMixin],
  watch: {
    pagination: {
      handler() {
        this.getAdminApplicationList()
      },
      deep: true
    },
  },
  methods: {
    formatPreciseDate: function(val) {
      if (!val) return ''
      var offset = moment().utcOffset()
      return moment
        .utc(val)
        .utcOffset(offset)
        .format('MMM D, YYYY h:mm:ss a')
    },
    signOffApp(inApplication) {
      var confMsg =
        'Are you sure you want to mark this Application as signed off?'

      if (inApplication.status == 0) {
        confMsg +=
          ' Since the application is in working status, this will fail unless it has ' +
          'been previously submitted'
      }

      confirm(confMsg) &&
        axiosAuthInstance
          .post('api/v1/admin/app/signoff/' + inApplication.applicationId)
          // eslint-disable-next-line no-unused-vars
          .then(response => {
            this.getAdminApplicationList()
          })
          .catch(error => {
            this.notifyAxiosError(
              error,
              'There was an error signing off the application'
            )
          })
    },
    resubmitApp(inApplication) {
      confirm('Are you sure you want to Resubmit this application?') &&
        axiosAuthInstance
          .post('api/v1/admin/app/resubmit/' + inApplication.applicationId)
          // eslint-disable-next-line no-unused-vars
          .then(response => {
            this.getAdminApplicationList()
          })
          .catch(error => {
            this.notifyAxiosError(
              error,
              'There was an error resubmitting the application'
            )
          })
    },
    repackageApp(inApplication) {
      confirm('Are you sure you want to Repackage this application?') &&
        axiosAuthInstance
          .post(
            'api/v1/admin/app/repackage/' + inApplication.applicationId
          )
          // eslint-disable-next-line no-unused-vars
          .then(response => {
            this.getAdminApplicationList()
          })
          .catch(error => {
            this.notifyAxiosError(
              error,
              'There was an error repackaging the application'
            )
          })
    },
    underwrite(inApplication) {
      confirm(
        'Are you sure you want to mark this Application as underwritten?'
      ) &&
        axiosAuthInstance
          .post(
            'api/v1/admin/app/underwrite/' + inApplication.applicationId
          )
          // eslint-disable-next-line no-unused-vars
          .then(response => {
            this.getAdminApplicationList()
          })
          .catch(error => {
            this.notifyAxiosError(
              error,
              'There was an error underwriting the application'
            )
          })
    },
    edit(inApplication) {
      this.application = Object.assign({}, inApplication)

      //set up the data for the expire date picker (remove time component)
      //If app is deleted, we don't allow changes to the expiration date
      //so don't need/want to muck with the format
      if (!this.application.deleted) {
        this.application.expirationDate = moment(this.application.expirationDate).toISOString().substr(0, 10);
      }

      this.applicationIndex = this.applications.indexOf(inApplication)

      EventBus.$emit('openAppEditDialog');
    },
    showEvents(inApplication) {
      this.application = inApplication
      axiosAuthInstance
        .get('api/v1/admin/app/events/'+inApplication.id)
        .then(response => {
          this.applicantEvents = response.data
          this.eventsDialog = true
        })
    },
    getLenderStatuses() {
      axiosAuthInstance
        .get('api/v1/admin/app/lenderStatuses')
        .then(response => {
          var lenderStatusesEnums = response.data
          this.lenderStatuses = []
          for (var i = 0; i < lenderStatusesEnums.length; i++) {
            this.lenderStatuses.push({
              value: lenderStatusesEnums[i],
              text: this.$t(
                'message.lenderStatusVals.' + lenderStatusesEnums[i]
              )
            })
          }
        })
    },
    getAdminApplicationList() {
      const page = this.pagination.page
      const rowsPerPage = this.pagination.rowsPerPage
      const offset = (page-1) * rowsPerPage

      this.loading = true
      // On Mounted grab working applications for admin users
      axiosAuthInstance
        .get('api/v1/admin/app/list/' + this.$store.getters.getDomain + "?filter="+this.search + "&limit="+rowsPerPage + "&offset="+offset)
        .then(response => {
          this.applications = response.data.applications
          this.totalApplications = response.data.totalApplications
        })
        .catch(error => {
          if (error.response && error.response.status == '401') {
            this.$router.push({
              //avoid issue with showing an error page for reset pw issue
              path: '/login'
            })
          } else {
            this.notifyAxiosError(
              error,
              'There was an error listing your applications'
            )
          }
        })
        .then(() => {
          this.loading = false
        })
    },
    updateApplicationInList() {
      this.applications.splice(this.applicationIndex,1, this.application)
    },
  },
  created() {
    this.getLenderStatuses()
    this.getAdminApplicationList()
  },
  mounted: function () {
    var vm = this;
    EventBus.$on('closeAppEditDialog', function () {
      vm.updateApplicationInList()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/AppList.vue